/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState,useEffect, useContext } from 'react';
import { motion } from "framer-motion";
import { useLocation, useNavigate } from 'react-router-dom';
import Filter from './Filter';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import StatusBar from '../StatusBar';
import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import AnimatedButton from '../Animation/AnimatedButton';
import { formatDate } from '../../CommonMethods/formatDate';
import GlobalContext from '../../components/Context/GloablContext';

const TopBarWithShadow = ({ 
    branchUser,
    isFeeStruct,
    ApplyFilter,
    loading,
    directoryPage,
    purchaseOrder, 
    ManageBranchListing,
    FilterData,
    isback,
    backTitle,
    backLocationFunction,
    backLocation,
    AddButton, 
    Tittle, 
    SearchInput, 
    AddButtonName, 
    handleOnClickSearch, 
    SearchValue, 
    isClick,
    customSearchBarWidth,
    filterFromPage,
    FilterCheckbox,
    setFilterCheckBox,
    handleApplyFilter,
    filterCount,
    customSearchPlaceHolder,
    handleFilters,
    status,
    searchParams,
    BranchDisabled,
    selectedFilterTerm,
    tooltip,
    handleThreeDottedButton,
    handleSidePopupClick,
    isSampleFileDownload,
    handleSampleFileDownload,
    dotedLoader,
    optimizedFn,
    handleImportFile,
    threeDottedButton,
    threeDottedButtonLoading,
    firstFilter,
    radioButton,
    showAddButtonalways,
    statusBarList,
    rightContent,
    isUpload,
    hideRightContentIfInactiveBranch = false,
    setIsSidePopup}) => {
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0] || firstFilter ||'city');
    const [dottedDopDown, setDottedDropDown] = useState(false);
    const location=useNavigate();
    const locate=useLocation()
    const threeDottedRef = useRef()
    useOnClickOutside(threeDottedRef, () => {
        setDottedDropDown(false)
    })
    
    const {  isInactiveBranch } = useContext(GlobalContext);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [searchValue1, setSearchValue] = useState(SearchValue || '');
    const [isClearVisible, setClearVisible] = useState(false);

    const outSideClick = useRef();
    const {userType}=useSelector(state=>state.auth)

    showAddButtonalways == (showAddButtonalways == undefined)?false:showAddButtonalways;

    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    useEffect(() => {
        if (SearchValue !== undefined) {
            setSearchValue(SearchValue);
            setClearVisible(SearchValue.length > 0);
        }
    }, [SearchValue]);

    useEffect(() => {
        if(selectedFilterTerm !== undefined ) {
            setSelectedFilter(selectedFilterTerm)
        }
        setClearVisible(searchValue1.length > 0);
    }, [locate])

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch(searchValue1);
        }
    };

    const clearAndperformSearch = (e) => {
        setSearchValue('');
        performSearch('');
    }

    const performSearch = (searchVal) => {
        searchVal = searchVal == undefined ? searchValue1 : searchVal;
        if (optimizedFn === undefined) {
            handleOnClickSearch('search', searchVal);
        } else {
            handleOnClickSearch(searchVal);
            optimizedFn !== undefined && optimizedFn('search', searchVal);
        }
    };

    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    const academicYearNames = params[item].split('),').map((year, index, arr) => {
                        // Add the closing parenthesis back to each element except the last one
                        return index < arr.length - 1 ? `${year})` : year;
                    });
                    filter_val[item] = isFeeStruct && item === 'academic_year' ? academicYearNames : params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen(!isFilterOpen)
    }
    
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: purchaseOrder === undefined ? formatDate(dateString, 'true') : dateString
            }))
        }  else if(radioButton !== undefined){
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } else {
            if(FilterCheckbox[selectedFilter] === undefined) {
                FilterCheckbox[selectedFilter] = [];
                setFilterCheckBox(FilterCheckbox);
            }
            const array = pushOrRemoveElement(FilterCheckbox[selectedFilter], selectedFilter === "status" ?id.toLowerCase() : id);
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:array
            }))
        }
    }
    const handleDottedDropDown = () => {
        setDottedDropDown(!dottedDopDown)
    }
    const handleClickDropDown = (e) => {
        setDottedDropDown(!dottedDopDown)
        handleThreeDottedButton(e)

    }
    return (
        <>
            <div className='mainDataCntnrTop shadow-s13' >
                {!branchUser ?
                    <div className='flex items-center'> 
                        {isback && <div className='flex items-center'  onClick={() => backLocationFunction ? backLocationFunction() : location(backLocation)}><a href="javascript:void(0)">
                            <img loading="lazy" decoding="async" src="/images/back-btnBlue.svg" alt="icon" title={backTitle}/>
                        </a></div>}
                        <h5 className={`pageHeader ${isback ? 'ml-2.5' : ''}`}>
                            {Tittle}</h5></div>
                    :
                    <p class="text-lg font-semibold text-[#000000]">{Tittle}</p>
                }
                <div className={`flex items-center`}>
                    {status!==undefined  && <StatusBar handleFilters={handleFilters} status={status} statusBarList={statusBarList}/>}
                    {SearchInput &&<div className="flex relative search-tab">
                        <label htmlFor="input"></label>
                        <div className="top-[52%] -translate-y-[50%]" id='search_button' >
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.9 }}
                                type="button"
                                // disabled={loading===true}
                                id="search-button"
                                className="inline-block"
                                data-te-toggle="modal"
                                data-te-target="#exampleModalCenter"
                                data-te-ripple-init
                                data-te-ripple-color="light">
                                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img"
                                />
                            </motion.button>
                        </div>
                        <div class="relative flex">
                            <input
                                maxLength={90}
                                type="text"
                                autoComplete='off'
                                id="search-value"
                                value={searchValue1}
                                // disabled={loading === true}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                className={`${customSearchBarWidth === undefined ? 'w-[220px]' : `w-[${customSearchBarWidth}]`} `}
                                placeholder={customSearchPlaceHolder}
                            />
                        </div>
                        {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                            <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                        </button> --> */}
                        {isClearVisible && <div className='absolute cross_icon' id='clear_icon' onClick={clearAndperformSearch} title='Clear Seach'>
                        </div>}
                    </div>}                    
                    {(ApplyFilter !== undefined && ApplyFilter) && (userType!=='branch-user'|| ManageBranchListing === undefined) && <div class="relative">
                        <button onClick={() => handleOpenFilter()} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            ref={outSideClick}
                            directoryPage={directoryPage}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            filterCount = {filterCount}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            tooltip={tooltip}
                            radioButton={radioButton}
                            filterFromPage={filterFromPage}
                        />}
                    </div>}
                    {AddButton && (!isInactiveBranch || showAddButtonalways) &&
                    <>{isClick===undefined?
                        <motion.button
                            // whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.9 }} 
                            onClick={() =>handleSidePopupClick('Add')}
                            disabled={BranchDisabled === undefined ? false : !BranchDisabled}
                            type="button"
                            className="prmy-btn" id="addAdmin_user" data-te-offcanvas-toggle
                            data-te-target="#offcanvasAddminUser" aria-controls="offcanvasAddminUser">
                            {AddButtonName}
                        </motion.button>:
                        <>
                            <motion.button
                                // whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.9 }} 
                                onClick={() =>location(isClick)}
                                type="button"
                                className="prmy-btn" id="addAdmin_user" data-te-offcanvas-toggle
                                data-te-target="#offcanvasAddminUser" aria-controls="offcanvasAddminUser">
                                {AddButtonName}
                            </motion.button>
                            {isUpload&&
                            (dotedLoader === "import" ?
                                <button 
                                    type="button" 
                                    className="prmy-btn" id="addAdmin_user" 
                                    onClick={() => handleSampleFileDownload()}
                                > <Loader />
                                </button>
                                :
                                <div className={`relative prmy-btn`}>
                                    <label className="cursor-pointer">
                                        <span>Upload</span>
                                        <input
                                            id="Upload"
                                            onChange={(e) => handleImportFile(e)}
                                            accept=".xlsx, .xls"
                                            data-allowed-file-extensions=".xlsx,.xls"
                                            type="file"
                                            className={`opacity-0 absolute top-0 left-0 w-full h-full importBtn`}
                                            title=""
                                        />
                                    </label>
                                </div> 
                            )}
                            {isSampleFileDownload&&
                            <button 
                                type="button" 
                                className="prmy-btn" 
                                id="sample" 
                                onClick={() => handleSampleFileDownload()}
                            > {dotedLoader === "sample" ? <Loader /> : "Sample File"}
                            </button>}
                            <div className='relative'ref={threeDottedRef}>
                                {threeDottedButton && 
                                    <button 
                                        type="button" 
                                
                                        className="more_actn_btn" 
                                        id="three_dotted" 
                                        onClick={() => {
                                            if(threeDottedButtonLoading){
                                                return;
                                            } else {
                                                handleDottedDropDown()
                                            }
                                        }}
                                    > 
                                        {threeDottedButtonLoading ? <div className='flex items-center justify-center pt-[5px] w-[34px]'>
                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-[20px] w-[20px] mb-4 spin-animation px-2"></div>
                                        </div> : <img src="/images/three_dotted_download.svg" alt="" />}
                                    </button>}
                                {(dottedDopDown && filterFromPage === 'Inventory') && <ul className='three_dot_btn_drp_dwn wid1 top1 shadow-s1'>
                                    <li>
                                        <AnimatedButton
                                            buttonName={"Issue Inventory"}
                                            link={"/inventory-master/inventory-list/issue-inventory"}
                                            className="w-full text-left px-3 cursor-pointer font-normal text-[#031624] hover:text-[#106EB4] " />
                                        
                                    </li>
                                    <li className='lst_sprtr'>

                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Sample Upload File"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4] mt-1.5" />
                                        
                                    </li>
                                    <li>
                                        <div className={`w-full text-left relative px-3 cursor-pointer font-normal text-[#031624] mt-3 hover:text-[#106EB4]`}>
                                            <label className="cursor-pointer">
                                                <span>Upload Inventory</span>
                                                <input
                                                    id="Upload"
                                                    onChange={(e) => handleClickDropDown(e)}
                                                    accept=".xlsx, .xls"
                                                    data-allowed-file-extensions=".xlsx,.xls"
                                                    type="file"
                                                    className={`opacity-0 absolute top-0 left-0 w-full h-full importBtn`}
                                                    title=""
                                                />
                                            </label>
                                        </div> 
                                        
                                    </li>
                                </ul>}
                                {(dottedDopDown && filterFromPage == 'Student_Directory') && <ul className='three_dot_btn_drp_dwn wid3 shadow-s1'>
                                    <li>   
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Upload Students"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4]" />
                                        
                                    </li>
                                    <li>   
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Update Fee Structure"}
                                            className="w-full text-left relative px-3 cursor-pointer font-normal text-[#031624] mt-3 hover:text-[#106EB4] mb-2" />
                                        
                                    </li>
                                    <li class="lst_sprtr"></li>
                                    { <li>   
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Send Parent Invitations"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] my-2 hover:text-[#106EB4]" />
                                        
                                    </li> }
                                    <li class="lst_sprtr"></li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Export Students"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4] my-2" />
                                    </li>
                                    <li class="lst_sprtr"></li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={handleClickDropDown}
                                            buttonName={"Transferred/Terminated Students"}
                                            className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4] mt-1.5" />
                                    </li>
                                </ul>}
                                {(dottedDopDown && filterFromPage === 'Invoices') && (
                                    <ul className='three_dot_btn_drp_dwn wid4 shadow-s1'>
                                        <li>
                                            <button
                                                id="Bulk Invoice Issue History"
                                                className="w-full text-left px-3 cursor-pointer font-normal text-[#031624] hover:text-[#106EB4] mt-1.5"
                                                onClick={handleClickDropDown}
                                            >
                                                Bulk Invoice Issue History
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </>
                    }
                    </>}
                    {true && <div class="flex items-center">{rightContent}</div>}
                </div>
            </div>
        </>  
    );
}

export default TopBarWithShadow
;
